<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Analyte Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="header" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit analyte'">
      <template #gated-content>
        <analyte-form :analyte="analyte" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import AnalyteForm from "@/components/lab/analyte/AnalyteForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { analyteNotifications } from "@/shared/notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const AnalyteRepository = LabRepositoryFactory.get("analyte");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "AnalyteEdit",
  components: {
    AnalyteForm,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      analyte_id: this.$route.params.analyte_id || null,
      analyte: null,
    };
  },
  computed: {
    sample_type() {
      return this.analyte.sample_type ? this.analyte.getSampleType() : null;
    },
    header() {
      return `Update ${
        this.sample_type ? this.sample_type.name : "Sample Type not specified"
      }: ${this.analyte.name}`;
    },
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/analytes",
            title: "Analyte list",
          },
          {
            icon: "fa-eye",
            linkto: `/analytes/${this.analyte_id}`,
            title: "View analyte",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await AnalyteRepository.update(this.analyte_id, form_data);

        this.addSuccess();
        this.$router.push(`/analytes/${this.analyte_id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.analyte = await getModel({
      model_type: "analyte",
      id: this.analyte_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: analyteNotifications,
};
</script>
